<template>
  <div class="address">
    <div class="address-header">
      新增收货地址
    </div>
    <div class="address-content">
      <div class="address-content-card">
        <Form ref="formRef">
          <Field
            v-model="state.name"
            name="name"
            label="收货人"
            placeholder="请输入收货人姓名"
            :rules="[{ required: true, message: '请填写收货人姓名' }]"
          />
          <Field
            v-model="state.mobile"
            name="mobile"
            label="手机号"
            placeholder="请输入收货人手机号"
            :rules="[{ required: true, message: '请填写收货人手机号' }]"
          />
          <Field
            v-model="state.region"
            is-link
            readonly
            label="所在地区"
            placeholder="请选择省市区"
            :rules="[{ required: true, message: '请选择省市区' }]"
            @click="state.showPicker = true"
          />
          <Field
            v-model="state.address"
            type="textarea"
            name="address"
            label="详细地址"
            placeholder="如道路、门牌号、小区、楼栋号、单元等"
            :rules="[{ required: true, message: '请填写详细地址' }]"
          />
        </Form>
      </div>
    </div>
    <div class="address-footer">
      <p>*购买成功后如需修改地址请联系助教学姐</p>
      <Button type="primary" round block @click="onSubmit">提交</Button>
    </div>
    <!-- 弹出层 -->
    <Popup v-model:show="state.showPicker" position="bottom" :style="{ height: '30%' }">
      <Picker :columns="regionList" :columns-field-names="customFieldName" @confirm="onConfirm" @cancel="state.showPicker = false" />
    </Popup>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted } from 'vue'
import { Form, Field, Picker, Popup, Button, showToast } from 'vant'
import { useRouter, useRoute } from "vue-router";
import { getDefaultAddress, saveAddress } from "@/api/user";
import regionList from "@/assets/json/pca-code.json"; // 引入城市数据

const router = useRouter();
const route = useRoute();

const customFieldName = {
  text: 'name',
  value: 'name',
}

const formRef = ref(null)

let state = reactive({
  name: '',
  mobile: '',
  region: '',
  regionList: [],
  address: ''
})

const onSubmit = () => {
  formRef.value.validate().then(async (values) => {
    console.log('submit', values)
    const saveAddressResponse = await saveAddress({
      name: state.name,
      mobile: state.mobile,
      province: state.regionList[0],
      city: state.regionList[1],
      district: state.regionList[2],
      address: state.address,
      defaultFlag: 1
    })
    if (saveAddressResponse.code === 200) {
      router.replace({
        path: '/pay',
        query: {
          ...route.query,
          addressId: saveAddressResponse.data,
          from: 'address'
        }
      })
    } else {
      showToast(saveAddressResponse.msg)
    }
  })
}

const onConfirm = ({ selectedValues }) => {
  state.region = selectedValues.join('-')
  state.regionList = selectedValues
  state.showPicker = false
}

onMounted(async () => {
  const defaultAddressResponse = await getDefaultAddress()
  if (defaultAddressResponse.code === 200) {
    const defaultAddress = defaultAddressResponse.data
    state.name = defaultAddress.name
    state.mobile = defaultAddress.mobile
    state.regionList = [defaultAddressResponse.data.province, defaultAddressResponse.data.city, defaultAddressResponse.data.district].filter(Boolean)
    state.region = state.regionList.join('-')
    state.address = defaultAddress.address
  }
})
</script>

<style lang="less" scoped>
.address {
  padding-bottom: 10px;
  min-height: 100%;
  background-color: #f5f5f5;
  display: flex;
  flex-direction: column;
  &-header {
    padding: 12px 0;
    background-color: #fff;
    text-align: center;
    font-size: 18px;
  }
  &-content {
    flex: 1;
    margin: 20px;
    &-card {
      border-radius: 10px;
      overflow: hidden;
    }
  }
  &-footer {
    padding: 20px 20px 60px 20px;
    text-align: center;
  }
}
</style>

<style lang="less">
.address {
  .van-popup {
    height: auto !important;
  }
}
</style>